import { Locale } from "./i18n";

export default {
    // Changed display name and code to Arabic
    display: "العربية",
    code: "ar",
    translation: {
        // Basic shape translations
        "arc.angle": "زاوية",
        "arc.start": "بداية",
        "axis.x": "المحور السيني",
        "axis.y": "المحور الصادي",
        "axis.z": "المحور العمودي",
        "body.arc": "قوس",
        "body.bolean": "عملية منطقية",
        "body.box": "صندوق",
        "body.circle": "دائرة",
        "body.face": "وجه",
        "body.fuse": "دمج",
        "body.imported": "مستورد",
        "body.line": "خط",
        "body.polygon": "مضلع",
        "body.prism": "منشور",
        "body.rect": "مستطيل",
        "body.revol": "دوران",
        "body.sweep": "كسح",
        "body.wire": "سلك",
        "box.dx": "الطول",
        "box.dy": "العرض",
        "box.dz": "الارتفاع",
        "body.editableShape": "شكل قابل للتحرير",
        "body.meshNode": "عقدة شبكية",
        "body.multiShape": "شكل متعدد",
        "circle.center": "المركز",
        "circle.radius": "نصف القطر",

        // Commands translations
        "command.arc": "قوس",
        "command.array": "مصفوفة",
        "command.bezier": "منحنى بيزييه",
        "command.boolean.common": "مشترك",
        "command.boolean.cut": "قص",
        "command.boolean.fuse": "دمج",
        "command.box": "صندوق",
        "command.break": "كسر",
        "command.circle": "دائرة",
        "command.copy": "نسخ",
        "command.delete": "حذف",
        "command.document.new": "مستند جديد",
        "command.document.open": "تحميل مستند",
        "command.document.save": "حفظ",
        "command.document.saveAs": "حفظ باسم",
        "command.document.saveToFile": "حفظ كملف",
        "command.export": "تصدير",
        "command.faceable.isFace": "وجه",
        "command.fuse": "دمج",
        "command.import": "استيراد",
        "command.line.isConnected": "متصل",
        "command.line": "خط",
        "command.mirror": "انعكاس",
        "command.mode.repeat": "تكرار",
        "command.move": "تحريك",
        "command.newFolder": "مجلد جديد",
        "command.newGroup": "مجموعة جديدة",
        "command.offset": "إزاحة",
        "command.polygon": "مضلع",
        "command.prism": "منشور",
        "command.rect": "مستطيل",
        "command.redo": "إعادة",
        "command.revol": "دوران",
        "command.rotate": "تدوير",
        "command.section": "مقطع",
        "command.split": "تقسيم",
        "command.sweep": "كسح",
        "command.thickSolid": "جسم سميك",
        "command.toFace": "إلى وجه",
        "command.toWire": "إلى سلك",
        "command.trim": "تشذيب",
        "command.undo": "تراجع",

        // Common terms
        "common.angle": "زاوية",
        "common.back": "رجوع",
        "common.cancel": "إلغاء",
        "common.clone": "استنساخ",
        "common.color": "لون",
        "common.confirm": "تأكيد",
        "common.general": "عام",
        "common.length": "طول",
        "common.material": "خامة",
        "common.matrix": "مصفوفة",
        "common.name": "اسم",
        "common.normal": "عمودي",
        "common.opacity": "شفافية",
        "common.thickness": "سماكة",
        "common.type": "نوع",

        // Entity related
        "entity.editable": "كيان قابل للتحرير",
        "entity.parameter": "كيان معلمي",

        // Error messages
        "error.default:{0}": "خطأ: {0}",
        "error.input.cannotInputANumber": "تداخل مع نقطة المرجع، لا يمكن إدخال رقم واحد",
        "error.input.invalidNumber": "الرجاء إدخال رقم صحيح، مفصول بفاصلة",
        "error.input.threeNumberCanBeInput": "نقطة المرجع فارغة، يمكن إدخال 3 أرقام فقط",
        "error.input.unsupportedInputs": "يتجاوز الحد الأقصى للمدخلات",
        "error.import.unsupportedFileType:{0}": "نوع الملف غير مدعوم: {0}",
        "error.export.noNodeCanBeExported": "لا يمكن تصدير أي عقدة",

        // File and home related
        "file.format": "تنسيق",
        "home.recent": "حديث",
        "home.welcome": "مرحباً بك في LuminiCAD",

        // Items and tools
        "items.header": "العناصر",
        "items.tool.delete": "حذف",
        "items.tool.expandAll": "توسيع الكل",
        "items.tool.newFolder": "مجلد جديد",
        "items.tool.unexpandAll": "طي الكل",

        // Line properties
        "line.end": "نهاية",
        "line.start": "بداية",
        "line.type.line": "خط",
        "line.type.xline": "خط X",

        // Material properties
        "material.texture.image": "صورة",
        "material.texture.rotation": "دوران",
        "material.texture.wrapS": "لف S",
        "material.texture.wrapT": "لف T",
        "material.texture.repeat": "تكرار",
        "material.texture.offset": "إزاحة",
        "material.map": "خريطة",
        "material.specular": "انعكاسي",
        "material.shininess": "لمعان",
        "material.emissive": "مشع",
        "material.specularMap": "خريطة الانعكاس",
        "material.normalMap": "خريطة العمودي",
        "material.bumpMap": "خريطة النتوء",
        "material.roughnessMap": "خريطة الخشونة",
        "material.emissiveMap": "خريطة الإشعاع",
        "material.metalness": "معدنية",
        "material.metalnessMap": "خريطة المعدنية",
        "material.roughness": "خشونة",

        // Model and operations
        "model.visible": "مرئي",
        "operate.pickCircleCenter": "اختر المركز، مفتاح ESC للإلغاء",
        "operate.pickFistPoint": "اختر النقطة الأولى، مفتاح ESC للإلغاء",
        "operate.pickNextPoint": "اختر النقطة التالية، مفتاح ESC للإلغاء",
        "operate.pickRadius": "أدخل نصف القطر، مفتاح ESC للإلغاء",
        "polygon.points": "نقاط",

        // Prompts and messages
        "prompt.default": "زر الماوس الأوسط للتحريك، Shift + زر الأوسط للتدوير، زر الأوسط للتكبير/التصغير",
        "prompt.deleteDocument{0}": "هل تريد حذف {0}؟",
        "prompt.polygon.close": "إغلاق",
        "prompt.saveDocument{0}": "هل تريد حفظ التغييرات في {0}؟",
        "prompt.select.edges": "الرجاء اختيار الحواف",
        "prompt.select.faces": "الرجاء اختيار الأوجه",
        "prompt.select.models": "الرجاء اختيار النماذج",
        "prompt.select.noModelSelected": "لم يتم اختيار نموذج",
        "prompt.select.shape": "الرجاء اختيار الشكل",
        "prompt.select.vertexs": "الرجاء اختيار الرؤوس",
        "prompt.select.wires": "الرجاء اختيار الأسلاك",

        // Properties and UI elements
        "properties.group.transform": "تحويل",
        "properties.header": "خصائص",
        "properties.multivalue": "قيمة متعددة",
        "rect.dx": "الطول",
        "rect.dy": "العرض",

        // Ribbon interface
        "ribbon.group.boolean": "عمليات منطقية",
        "ribbon.group.converter": "محول",
        "ribbon.group.draw": "رسم",
        "ribbon.group.importExport": "استيراد/تصدير",
        "ribbon.group.modify": "تعديل",
        "ribbon.group.selection": "تحديد",
        "ribbon.group.tools": "أدوات",
        "ribbon.group.workingPlane": "مستوى العمل",
        "ribbon.tab.draw": "رسم",
        "ribbon.tab.file": "ملف",
        "ribbon.tab.startup": "المحرر",

        // Snap options
        "snap.center": "مركز",
        "snap.end": "نهاية",
        "snap.intersection": "تقاطع",
        "snap.mid": "منتصف",
        "snap.perpendicular": "عمودي",
        "snap.nearest": "الأقرب",

        // Toast messages
        "toast.command.{0}excuting": "الأمر {0} قيد التنفيذ",
        "toast.converter.error": "خطأ في التحويل",
        "toast.converter.invalidColor": "اللون غير صالح",
        "toast.delete{0}Objects": "تم حذف {0} عناصر",
        "toast.document.noActived": "لا يوجد مستند نشط",
        "toast.document.saved": "تم حفظ المستند",
        "toast.downloading": "جاري التحميل",
        "toast.excuting{0}": "تنفيذ {0}",
        "toast.fail": "فشل",
        "toast.read.error": "خطأ في القراءة",
        "toast.select.noSelected": "لم يتم التحديد",
        "toast.success": "نجاح",

        // Transform options
        "transform.rotation": "دوران",
        "transform.scale": "مقياس",
        "transform.translation": "انتقال",
        "vertex.point": "نقطة",

        // Working plane
        "workingPlane.alignToPlane": "محاذاة للمستوى",
        "workingPlane.set": "تعيين مستوى العمل",
        "test.performace": "اختبار الأداء",

        // AI Chat
        "chat.title": "المساعد الذكي",
        "chat.placeholder": "اكتب طلب التصميم الخاص بك...",
        "command.ai.chat": "محادثة ذكية",

        // Working plane
        "workingPlane.toggleDynamic": "تفعيل/تعطيل مستوى العمل الديناميكي",
        "workingPlane.fromSection": "إنشاء مستوى عمل من المقطع",

        // Labels for Shapes List panel in chat header (Arabic)
        "chat.shapesList.currentDocument": "أشكال المستند الحالي",
        "chat.shapesList.allDocuments": "أشكال من مستندات أخرى",
        "chat.shapesList.noDocument": "لا يوجد مستند نشط لعرض الأشكال.",
        "chat.shapesList.noStorage": "التخزين غير متاح لجلب المستندات.",
        "chat.shapesList.errorLoading": "خطأ في تحميل قائمة الأشكال.",

        "body.cylinder": "أسطوانة",
        "body.cone": "مخروط",
        "body.sphere": "كرة",
        "body.ellipse": "قطع ناقص",
        "body.pyramid": "هرم",
        "ellipsoid.radiusX": "نصف القطر X (إليبسويد)",
        "ellipsoid.radiusY": "نصف القطر Y (إليبسويد)",
        "ellipsoid.radiusZ": "نصف القطر Z (إليبسويد)",
        "ellipse.majorRadius": "نصف القطر الكبير (قطع ناقص)",
        "ellipse.minorRadius": "نصف القطر الصغير (قطع ناقص)",
        "command.pyramid": "هرم",
        "command.cylinder": "أسطوانة",
        "command.cone": "مخروط",
        "command.sphere": "كرة",
        "command.ellipse": "قطع ناقص",
        "command.chamfer": "تقويس",
        "command.copySubShape": "نسخ الشكل الفرعي",
        "command.explode": "تفكيك",
        "command.fillet": "تقويس",
        "command.removeFeature": "حذف الميزة",
        "command.removeSubShapes": "حذف الشكل الفرعي",
        "command.toShell": "تحويل إلى جدار",
        "command.toSolid": "تحويل إلى جسم",
        "ribbon.group.2d": "2D",
        "ribbon.group.3d": "3D",
        "ribbon.group.other": "أخرى",
        "ribbon.tab.tools": "أدوات",
        "statusBar.snap": "التقاط",
        "statusBar.tracking": "التتبع",
    },
} satisfies Locale;
